export enum paths {
  auth = '/auth',
  main = '/',
  users = '/users',
  managers = '/managers',
  questions = '/questions',
  settings = '/settings/*',
  passwordRecover = 'user/password-recover'
}
